export const APIUrls = {
  VERSION_URL: "/version",
  LOGIN_URL: "/login",
  SYSTEM_SETTINGS: {
    SYSTEM_SETTINGS_GET: "/systemSetting",
    SYSTEM_SETTINGS_EDIT_OR_CREATE: "/systemSetting",
  },
  GENERIC_LOGS: {
    GENERIC_LOGS_GET: "/genericLogs",
    GENERIC_LOGS_ADD: "/genericLogs",
  },
  ENDUSERS: {
    ENDUSERS_GET: "/user",
    CHANGE_PASSWORD: "/user/password",
    ENDUSERS_GET_LIST: "/user/list",
    ENDUSERS_GET_ROLES: "/user/roles",
    ENDUSERS_UPDATE: "/user/enduser",
    ENDUSERS_UPDATE_ROLE: "/user/enduser/role",
    ENDUSERS_DELETE_ROLE: "/user/enduser/role",
  },
  SENSORS: {
    SENSORS_URL: "/sensors/fulllist",
    SENSOR_EDIT_OR_CREATE: "/sensors/createOrEdit",
    SENSOR_DELETE: "/sensors/delete",
  },
  CARINGS: {
    CARINGS_GET: "/carings",
    CARINGS_INSERT: "/carings",
    CARINGS_UPDATE: "/carings",
    CARINGS_DELETE: "/carings",
  },
  ALARMS: {
    ALARMS_URL: "/alarms",
    NEW_ALARMS_URL: "/alarms/new",
    ALARMS_BY_ID: "/alarms/:alarmId",
  },
  SENTINELS: {
    SENTINELS_ALL_URL: "/sentinels/all",
    SENTINELS_URL: "/sentinels",
    SENTINELS_VALIDATE_CAM: "/sentinels/validateCamSession",
    SENTINEL_BY_ID_URL: "/sentinels/:sentinelId",
    SENTINEL_SENSOR_VALUES_URL: "/sentinels/:sentinelId/sensors",
    SENTINEL_SENSOR_UPDATE_URL: "/sentinels/:sentinelId/:sensorId",
    SENTINEL_LED_STATUS_URL: "/sentinels/:sentinelId/led",
    SENTINEL_LOGICAL_DELETE: "/sentinels/admin/delete",
    SENTINEL_LOGICAL_RESTORE: "/sentinels/admin/restore",
  },
  TEST_ALARMS: {
    TEST_ALARM_INFO: "/sentinels/:sentinelId/test-alarm/info",
    TEST_ALARM_SEND: "/sentinels/:sentinelId/sensors/:sensorId/test-alarm",
  },
  PATIENTS: {
    PATIENTS_URL: "/patients",
    PATIENTS_UPDATE_URL: "/patients/:patientId",
    PATIENTS_UPDATE_META_URL: "/patients/:patientId/meta",
  },
  NOTIFICATIONS: {
    NOTIFICATIONS_URL: "/notifications",
    NOTIFICATIONS_RETRY: "/notifications/:id/retry",
  },
  TRACES: {
    TRACES_URL: "/sensorstatustrace",
    TRACES_URL_LIST: "/sensorstatustrace/list",
    TRACES_URL_LIST_ALL: "/sensorstatustrace/list/all",
  },
};
